module.exports = __webpack_public_path__ + "./docs/img/icon-java.df229f06ca9fea3d9c32853ca450c188.svg";